<template>
  <div :class="readingStyle">
    <div class="article-content" v-html="caseTitle"></div>

    <annot8-article
      :doc-id="id"
      :content="content"
      docType="law"
      ref="annot8"
    ></annot8-article>

    <div v-if="popupContent">
      <div id="popupMenu" style="display: none">
        <popup-menu ref="popupmenu" :docId="id" docType="law"></popup-menu>
      </div>
      <div id="popupAdd" style="display: none">
        <popup-add :docs="docs" docType="law"></popup-add>
      </div>
    </div>
    <help v-if="popupContent" id="popupHelp" style="display: none" />
  </div>
</template>
<script>
import Annot8Article from "@/components/annot8/Annot8Article";
import Menu from "./PopupMenu";
import Add from "@/views/notebooks/PopupAddToNotebook.vue";
import Help from "@/components/Help.vue";

export default {
  data() {
    return {
      id: null,
      title: "",
      shortTitle: "",
      content: "",
      ponente: "",
      enbanc: false,
      popupContent: true,
      docTitle: "",
      showFull: false,
    };
  },

  computed: {
    docs() {
      return [{ docid: this.id, shortTitle: this.shortTitle || this.title }];
    },
    readingStyle() {
      return [
        "reading-" +
          (this.$store.state.settings.settings.readingMode || "normal"),
        "textsize-" +
          (this.$store.state.settings.settings.textSize || "normal"),
      ];
    },
    caseTitle() {
      if (!this.showFull) {
        const regexp = /(<h3>)(.*?)(?=(<\/h3(.*?)>))/is;
        const matches = this.docTitle.match(regexp);
        if (matches) {
          if (matches.length > 0) {
            return this.docTitle.replace(
              matches[2],
              `${this.shortTitle} <a onclick="showFullTitle(event)" href="#" class="case-more-title">+</a>`
            );
          }
        }
      }

      return this.docTitle;
    },
  },

  methods: {
    async load(id) {
      this.id = id;

      var doc = {};

      const laws = this.$store.state.history.recent.laws || [];

      const lawIdx = laws.findIndex((l) => l.id === id);

      if (lawIdx >= 0) {
        doc = { data: laws[lawIdx] };
      } else {
        doc = await this.$lawyerly.laws.view({ id: id });
      }

      this.title = doc.data.title;
      this.shortTitle = doc.data.shortTitle;

      //get title
      let content = doc.data.content;
      // content = content.replace(/<CENTER>/g, '<center>');
      // content = content.replace(/<\/CENTER>/g, '</center>');
      // content = content.replace(/<BR>/g, '<br />');
      // content = content.replace(/<br>/g, '<br />');
      // content = content.replace(/<BR \/>/g, '<br />');
      // content = content.replace(/<H3>/g, '<h3>');
      // content = content.replace(/<\/H3>/g, '</h3>');

      // const m = content.match(/.*?<\/center>/s);
      // if(m.length > 0) {
      //   this.docTitle = m[0];
      // }

      // cleanup
      // var tdoc = document.createElement("div");
      // tdoc.innerHTML = content.replace(/.*?<\/center>/s, "");
      // var styles = tdoc.querySelectorAll("style");
      // var remove = [];
      // var all = tdoc.getElementsByTagName("*");
      // Array.prototype.forEach.call(all, s => {
      //   if (["STYLE", "SCRIPT"].includes(s.tagName)) {
      //     remove.push(s);
      //   }
      //   if (["SUP"].includes(s.tagName)) {
      //     s.outerHTML = `<${s.tagName}>${s.innerHTML}</${s.tagName}>`;
      //   }
      // });
      // remove.forEach(r => {
      //   r.remove();
      // });

      // optimized cleanup
      content = content.replace(/(<style)(.*?)\>(.*?)(<\/style>)/is, "");
      content = content.replace(/(<script)(.*?)\>(.*?)(<\/script>)/is, "");

      //get title
      const m = content.match(/.*?<\/center>/is);
      if (m.length > 0) {
        this.docTitle = m[0];
      }

      this.content = content.replace(/.*?<\/center>/is, "");
      // this.content = content;
      this.$store.commit("history/addRecent", {
        data: { ...doc.data, id: id },
        type: "laws",
      });

      this.$root.mountPrintable(this.docTitle, this.content);
    },
    more(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          translucent: true,
        });
      }, 200);
    },

    addToNotebook(evt) {
      if (!this.$store.getters["user/isAuthenticated"]) {
        this.$router.push("/profile/login");
        return;
      }

      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(null, {
          template: "popupAdd",
          cssClass: "wide-width-popup",
          translucent: true,
        });
      }, 200);
    },

    onHeaderCommand(event, cmd) {
      switch (cmd.cmd) {
        case "more":
          this.more(event);
          break;
        case "add":
          this.addToNotebook();
          break;
        case "share":
          this.share();
          break;
        case "clear":
          this.clear();
          break;
        case "help":
          this.help();
          break;
      }
    },

    clear() {
      this.$refs["popupmenu"].clear();
    },

    share() {
      this.$refs["popupmenu"].share();
    },

    help() {
      this.popupContent = false;
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(null, {
          template: "popupHelp",
          cssClass: "wide-width-popup",
          translucent: true,
        });
      }, 200);
    },

    showFullTitle(e) {
      e.preventDefault();
      this.showFull = true;
      this.$refs["annot8"].onRead();
    },
  },

  mounted() {
    window.showFullTitle = this.showFullTitle;
    this.load(this.$store.state.route.params.id);

    this.$store.commit("ui/setMoreHeaderButtons", {
      mobile: [{ icon: "more", emit: "header-command", cmd: "more" }],
      web: [
        {
          label: "help",
          icon: "help-circle",
          disabled: false,
          emit: "header-command",
          cmd: "help",
        },
        // { label: "share", icon: "share", disabled: false, emit: "header-command", cmd: "share" },
        {
          label: "add to notebook",
          icon: "bookmark",
          disabled: false,
          emit: "header-command",
          cmd: "add",
        },
      ],
    });
    this.$root.$on("header-command", this.onHeaderCommand);
    this.$watch(
      () => {
        return this.$refs["annot8"].state.annotations.length;
      },
      () => {
        if (this.$refs["annot8"].state.annotations.length > 0) {
          this.$store.commit("ui/ShowClearHighlights", true);
        } else {
          this.$store.commit("ui/ShowClearHighlights", false);
        }
      }
    );
  },

  beforeDestroy() {
    this.$root.unMountPrintable();
    this.$store.commit("ui/setMoreHeaderButtons", { mobile: [], web: [] });
    this.$root.$off("header-command", this.onHeaderCommand);
    this.$store.commit("ui/ShowClearHighlights", false);
  },

  components: {
    "annot8-article": Annot8Article,
    "popup-menu": Menu,
    "popup-add": Add,
    help: Help,
  },
};
</script>
<style></style>
